import client from '../httpClient';

const settingGroupStoreDeleteApi = (params) => {
  return client.delete('/store-groups/settings/', { params, isShowMessage: true });
};

export default settingGroupStoreDeleteApi;
